import { Typography } from '@mui/material';

interface InfoStripProps {
  text: string;
  className?: string;
}

export const InfoStrip: React.FC<InfoStripProps> = ({ text, className }) => {
  return (
    <div className={`bg-background rounded-lg text-center px-6 py-10 ${className}`}>
      <Typography variant="h4" component="h4">
        {text}
      </Typography>
    </div>
  );
};
